import { render } from "./history.vue?vue&type=template&id=0f63f71d&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"

import "./history.vue?vue&type=style&index=0&id=0f63f71d&scoped=true&lang=scss"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f63f71d"]])

export default __exports__